import {atom} from "jotai";

export const datesAtom = atom([]);